/*
 * Cohort 001 popup.
 * Claude QA 10-7:
 *  - minimum 15s delay (theme setting was 5s and the popup covered Add to Bag on PDPs)
 *  - on product pages: wait for 30s or 50% scroll, whichever comes first
 *  - wait until the cookie banner has been answered
 *  - a dismissal is remembered for 14 days, not just this visit
 */
class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Math.max(Number(this.dataset.delay) || 0, 15);
    this.isProductPage = document.body.classList.contains("template-product");

    if (this.hasSubscription || this.isDismissed()) return;

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (event) => {
        event.preventDefault();
        this.popup.classList.add("hidden");
        this.markDismissed();
      });
    }

    this.waitForConsent(() => this.schedule());
  }

  schedule() {
    let shown = false;
    const show = () => {
      if (shown || this.isDismissed()) return;
      shown = true;
      window.removeEventListener("scroll", onScroll);
      this.popup.classList.remove("hidden");
      this.popup.classList.add("wt-popup-fade-in");
    };

    if (this.isProductPage) {
      var onScroll = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= 0.5) show();
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      setTimeout(show, 30000);
    } else {
      var onScroll = () => {};
      setTimeout(show, this.delay * 1000);
    }
  }

  waitForConsent(callback) {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.shouldShowBanner === "function" && privacy.shouldShowBanner()) {
        document.addEventListener("visitorConsentCollected", () => callback(), { once: true });
        return;
      }
    } catch (e) {}
    callback();
  }

  isDismissed() {
    try {
      if (sessionStorage.getItem("hideNotificationPopup") === "true") return true;
    } catch (e) {}
    try {
      const until = Number(localStorage.getItem("hideNotificationPopupUntil") || 0);
      return until > Date.now();
    } catch (e) {
      return false;
    }
  }

  markDismissed() {
    try {
      sessionStorage.setItem("hideNotificationPopup", "true");
    } catch (e) {}
    try {
      localStorage.setItem("hideNotificationPopupUntil", String(Date.now() + 14 * 24 * 60 * 60 * 1000));
    } catch (e) {}
  }
}

customElements.define("notification-popup", NotificationPopup);
